"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emojis = exports.contentStyles = exports.expandedControlBarStyles = exports.controlBarStyles = void 0;
exports.controlBarStyles = {
    height: "48px",
    border: "2px solid #F5F5F5",
    backgroundColor: "#F5F5F5",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
    paddingLeft: "1rem",
    paddingRight: "1rem",
};
exports.expandedControlBarStyles = {
    height: "48px",
    border: "2px solid #F5F5F5",
    backgroundColor: "#F5F5F5",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
};
exports.contentStyles = {
    overflowY: "auto",
    border: "2px solid #F5F5F5",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    // comes from the controlBar
    borderTop: "unset",
};
exports.emojis = [
    "🤣",
    "🙌",
    "💚",
    "💛",
    "👏",
    "😉",
    "💯",
    "💕",
    "💞",
    "💘",
    "💙",
    "💝",
    "🖤",
    "💜",
    "❤️",
    "😍",
    "😻",
    "💓",
    "💗",
    "😋",
    "😇",
    "😂",
    "😹",
    "😘",
    "💖",
    "😁",
    "😀",
    "🤞",
    "😲",
    "😄",
    "😊",
    "👍",
    "😌",
    "😃",
    "😅",
    "✌️",
    "🤗",
    "💋",
    "😗",
    "😽",
    "😚",
    "🤠",
    "😙",
    "😺",
    "👄",
    "😸",
    "😏",
    "😼",
    "👌",
    "😎",
    "😆",
    "😛",
    "🙏",
    "🤝",
    "🙂",
    "🤑",
    "😝",
    "😐",
    "😑",
    "🤤",
    "😤",
    "🙃",
    "🤡",
    "😶",
    "😪",
    "😴",
    "😵",
    "😓",
    "👊",
    "😦",
    "😷",
    "🤐",
    "😜",
    "🤓",
    "👻",
    "😥",
    "🙄",
    "🤔",
    "🤒",
    "🙁",
    "😔",
    "😯",
    "😰",
    "😩",
    "😖",
    "😕",
    "😒",
    "😣",
    "😢",
    "😮",
    "😿",
    "🤧",
    "😫",
    "🤥",
    "😞",
    "😬",
    "👎",
    "💀",
    "😳",
    "😨",
    "🤕",
    "🤢",
    "😱",
    "😭",
    "😠",
    "😈",
    "😧",
    "💔",
    "😟",
    "🙀",
    "💩",
    "👿",
    "😡",
    "😾",
];
